import React from 'react';
import Link from 'react-router/lib/Link';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import cn from 'classnames';

import { HEALTHBOARD_HOME } from '../../../constants/routes';
import styles from '../index.styl';

const MenuItems = ({ items }) => {
  const isHomeForAR = window.location.pathname.includes(HEALTHBOARD_HOME);

  return items.map(item => {
    const { href, title } = item;
    const isHomeLink = href.includes(HEALTHBOARD_HOME);

    return (
      <li
        styleName={cn('item', { linkActiveAR: isHomeLink && isHomeForAR })}
        key={item.id}
      >
        <Link
          activeClassName={styles['link--active']}
          children={title}
          styleName="link"
          to={`/${href}`}
          id={item.id}
        />
      </li>
    );
  });
};

MenuItems.propTypes = {
  items: PropTypes.array,
};

export default CSSModules(MenuItems, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Header/Components/MenuItems.jsx